import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Vendors } from 'app/_models/vendors';
import { Observable, Subject } from 'rxjs';
import { UserModel } from 'app/_models/user-model';
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CrudVendorService {
  private _refreshrequired = new Subject<void>();
  _baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) {
    this._baseUrl = environment.baseUrl;
   }

   currentUser: UserModel;
   
   get Refreshrequired() {
    return this._refreshrequired;
  }

  getAllVendors() {
    return this.http.get<Vendors[]>(this._baseUrl + 'Common/GetAllVendors');
  }

  deleteVendor(vendorcode:string): Observable<any> {
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));
    let model = {id: vendorcode, updatedBy: this.currentUser.userId}
      //return this.http.post<any>(this._baseUrl +'Product/DeleteProduct', model);
      return this.http.post<any>(this._baseUrl +'Common/DeleteVendor', model).pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
    }
  
    updateVendor(model:any):Observable<any>
    {
      return this.http.post<any>(this._baseUrl + 'Common/UpdateVendor', model).pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
    }
 

  getActiveVendors() {
    return this.http.get<Vendors[]>(this._baseUrl + 'Common/getActiveVendors');
  }

  getPagedActiveVendors(model:any): Observable<any>{
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
    let options = { headers: headers,  withCredentials: true  };
    return this.http.post<any>(`${this._baseUrl}Common/getActiveVendors`, model, options);
  }

  addVendor(model:any):Observable<any>
  {
    return this.http.post<any>(this._baseUrl + 'Common/SaveVendor', model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
  }


  
}
 